import React from 'react';

const blockedRegex = [/^(https?:\/\/)wcc.com([^a-z0-9]|$)/i];

function ExternalLink({ href, children, ...otherProps }) {
  if (blockedRegex.some(r => r.test(href))) {
    return children;
  } else {
    return (
      <a href={href} {...otherProps}>
        {children}
      </a>
    );
  }
}

export default ExternalLink;
